<rb-dialog (buttonClick)="onDialogButtonClick($event)" [config]="dialogConfig">
  <div class="flex flex-col gap-y-[1rem]">
    <div class="font-bold">{{ 'APP.DOCUMENT.DELETE_DOCUMENT.DIALOG.QUESTION' + translationKeySuffix | translate }}</div>
    <rb-view-section>
      <rb-selected-documents [documents]="request.documents"
                             class="block max-h-[50rem] overflow-scroll"></rb-selected-documents>
    </rb-view-section>
    <div class="text-secondary text-sm">
      {{ 'APP.DOCUMENT.DELETE_DOCUMENT.DIALOG.INFO' + translationKeySuffix | translate }}
    </div>
  </div>
</rb-dialog>
